const KEY = "activeEventId";

export function getStoredActiveId(): string | null {
  return localStorage.getItem(KEY) || null;
}

export function setStoredActiveId(id: string): void {
  localStorage.setItem(KEY, id);
}
